require('../app');

import AuthorList from '@componentPath/author/authorList';
const author_list = Vue.createApp({});

author_list.component('author-list', AuthorList);
author_list.config.devtools = true; // @todo 對此instance 開啟dev tool
author_list.mount('#author_article_list');
